module.exports = __webpack_public_path__ + "cd3bd5fcbeeea0544009fc9c37376ef6.jpg";